import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

import { GPayMark } from '../../../../ucl/themes/icons';

import { IBraintreeButton } from './types';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  height: '44px',
  accessible: true,
  accessibilityRole: 'button',
  accessibilityLabel: 'GooglePay',
  _text: {
    fontSize: 'xl',
    textAlign: 'center',
    color: '#FFF',
  },
  backgroundColor: '#000000',
  padding: 0,
});

export const GooglePayButton: React.FC<IBraintreeButton> = ({
  onPress,
  isLoading,
}: IBraintreeButton) => {
  return (
    <StyledButton
      fullWidth
      isLoading={isLoading}
      onPress={onPress}
      rightIcon={<GPayMark size={100} height={50} width={100} marginRight="$5"></GPayMark>}
      padding={isLoading ? 3 : 0}
    />
  );
};
